import { type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { IS_COMMUNITY_ENABLED } from '@/configs/community';
import { ROUTE_ALIASES } from '@/routing/routesAliases';

type CommunityFeatureGuardProps = {
  children: ReactNode;
};

export const CommunityFeatureGuard = ({ children }: CommunityFeatureGuardProps) => {
  if (!IS_COMMUNITY_ENABLED) {
    return <Navigate to={ROUTE_ALIASES.HOME} replace />;
  }

  return children;
};
